import type { TimelineItem } from '@bbpos/ui';
import type { StockHistoryItem } from '@/types/product';

const MOVEMENT_LABELS: Record<string, string> = {
  PURCHASE: 'Purchase',
  SALE: 'Sale',
  RETURN: 'Return',
  ADJUSTMENT: 'Adjustment',
  DAMAGE: 'Damage',
  WASTAGE: 'Wastage',
  EXPIRY_WRITE_OFF: 'Expiry write-off',
  OPENING_STOCK: 'Opening stock',
  TRANSFER_OUT: 'Transfer out',
  TRANSFER_IN: 'Transfer in',
};

/** Human label for a stock movement type; unknown types read as "Some type". */
export function movementLabel(type: string): string {
  if (MOVEMENT_LABELS[type]) return MOVEMENT_LABELS[type];
  const words = type.toLowerCase().replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/**
 * One "Stock movements" row. Every movement is already applied to the stock,
 * so the badge names the movement (coloured by direction), never a status (IS1-002).
 */
export function stockMovementTimelineItem(
  h: StockHistoryItem,
  product: { name: string; unit: string },
): TimelineItem {
  return {
    id: h.id,
    timestamp: h.created_at,
    action: `${h.quantity > 0 ? '+' : ''}${h.quantity} ${product.unit}`,
    // A parent's history includes its variants' movements — name the variant.
    description: [h.product_name && h.product_name !== product.name ? h.product_name : null, h.notes]
      .filter(Boolean)
      .join(' · '),
    actor: h.created_by_name ?? 'System',
    type: h.quantity > 0 ? 'success' : 'warning',
    label: movementLabel(h.type),
  };
}
